
import React from 'react';
import { cn } from '@/lib/utils';
import NavMenuItems from './NavMenuItems';
import NavLink from './NavLink';
import { useLanguage } from '@/hooks/useLanguage';
import { useTranslation } from '@/lib/i18n';

import { Settings } from 'lucide-react';
import { ConsortiumInvitations } from '../notifications/ConsortiumInvitations';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

interface DesktopNavigationProps {
  isHomePage: boolean;
  isScrolled: boolean;
  user: any;
  member: any;
  isAdmin: boolean;
  isMember: boolean;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = React.memo(({ isHomePage, isScrolled, user, member, isAdmin, isMember }) => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  
  return (
    <nav className="hidden md:flex items-center space-x-6">
      {!isMember && !isAdmin && (
        <NavigationMenu>
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuTrigger 
                className="font-medium transition-all duration-300 text-white hover:text-singu-yellow focus:text-singu-yellow data-[state=open]:text-singu-yellow bg-transparent border-0 shadow-none"
              >
                {t('visionMission')}
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <ul className="grid gap-3 p-4 w-[400px]">
                  <NavMenuItems isHomePage={isHomePage} isScrolled={isScrolled} />
                </ul>
              </NavigationMenuContent>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
      )}

      {(isMember || isAdmin) && (
        <NavLink to="/dashboard" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="font-semibold text-singu-yellow">Hub SC</NavLink>
      )}
      <NavLink to="/members" isPage isScrolled={isScrolled} isHomePage={isHomePage}>Annuaire</NavLink>
      <NavLink to="/networking" isPage isScrolled={isScrolled} isHomePage={isHomePage}>Networking</NavLink>
      <NavLink to="/opportunities" isPage isScrolled={isScrolled} isHomePage={isHomePage}>Opportunités</NavLink>
      <NavLink to="/events" isPage isScrolled={isScrolled} isHomePage={isHomePage}>Événements</NavLink>
      <NavLink to="/insights" isPage isScrolled={isScrolled} isHomePage={isHomePage}>Insights</NavLink>
      <NavLink to="/workshops" isPage isScrolled={isScrolled} isHomePage={isHomePage}>Workshops</NavLink>
      
      {user && <ConsortiumInvitations />}

      {isAdmin && (
        <NavLink 
          to="/admin" 
          isPage 
          isScrolled={isScrolled}
          isHomePage={isHomePage}
          className="flex items-center gap-2 text-singu-yellow hover:underline"
        >
          <Settings className="h-4 w-4" />
          Administration
        </NavLink>
      )}
    </nav>
  );
});

export default DesktopNavigation;
